<template>
  <v-footer
    :absolute="!focusMode"
    :app="!focusMode"
    padless
    class="
      d-flex flex-column
      pt-12 pb-6
    "
  >
    <v-divider class="col-12 px-0 mx-0" />

    <span
      class="
        grey--text text--darken-2
      "
    >
      {{ new Date().getFullYear() }} - <strong>UCPA</strong>
    </span>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    focusMode () {
      return this.$store.state.focusMode;
    }
  }
};
</script>
